module.exports = __webpack_public_path__ + "img/NHNKCP_CI_Basic.30d7b2e6.png";